import { Box, Button, Typography } from '@mui/material';
import { createColumnHelper } from '@tanstack/react-table';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import eOpsLogo from '../../../images/eops.png';
import excel from '../../../images/excel.png';
import mepcoLogo from '../../../images/mepcoLogo.png';
import pdf from '../../../images/pdf.png';
import print from '../../../images/print.png';
import { cfpBaseUrl } from '../../../network/urls';
import { convertDate, convertDatewithTime, getName, numberFormatting } from '../../../services/Functions';
import { internalIconStyles } from '../../../style/common';
import '../../../style/common.scss';
import CircularProgress from "@mui/material/CircularProgress";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../../images/pitc.png';
const EopsMobileAppUsageSummary = () => {
    const columnHelper = createColumnHelper();
    const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId,hierarchy: userHierarchy } = useSelector(state => state.auth)
    const companyCode = code.slice(0, 2)
     const offCode = userHierarchy == 1
    ? code
    : userHierarchy == 2
      ? code.slice(0, 2)
      : userHierarchy == 3
        ? code.slice(0, 3)
        : userHierarchy == 4
          ? code.slice(0, 4)
          : userHierarchy == 5
            ? code.slice(0, 5)
            : code;
    const tableRef = useRef(null);
    const [assmntBatchWise, setAssmntBatchWise] = useState([]);
    // const { officeCode: offCode } = useSelector(state => state.officeCode)
    const [tableData, setTableData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [circleCode, setCircleCode] = useState('');
    const [circleName, setCircleName] = useState('');
    const [officeCode, setOfficeCode] = useState();
    const [officeName, setOfficeName] = useState('');
    const [desginationList, setDesginationList] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedSubDivision, setSelectedSubDivision] = useState('');
    const [filteredDivisions, setFilteredDivisions] = useState([]);
    const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
    const [hierarchy, setHierarchy] = useState('');
    const [filteredCircles, setFilteredCircles] = useState([]);
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [desginationCodeToApi, setDesginationCodeToApi] = useState("95");
    const [desginationName, setDesginationName] = useState("LS-I");
    const [isGoDisabled, setIsGoDisabled] = useState(true); 
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
    const OffLevel = String(officeCode).length;
       const [selectedCompanyCode, setSelectedCompanyCode] = useState('');
         const [subDivisions, setSubDivisions] = useState(JSON.parse(window.localStorage.getItem('subDivisions')) || []);
    const [currentBillingStats, setCurrentBillingStats] = useState({
        batches: [],
        amountsBatchWise: [],
        unitsBatchWise: [],
        categories: ['Total', 'Dom.', 'Com.', 'Ind.', 'Arg.', 'Oth.'],
        amountsCategoryWise: [],
    })
    const [billingReportPopup, setBillingReportPopup] = useState(false);
   
    useEffect(() => {
        const getDesgination = async () => {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            const raw = "";
            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };
            fetch(cfpBaseUrl + "workForce/getListOfSubDivisionDesignations", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setViewBackdrop(false);
                    if (result.message == 'Data Found.') {
                        const fieldStaffList = result.data.filter(item => item.isFieldStaff === 1);
                        setDesginationList(fieldStaffList);
                    }
                })
                .catch((error) => console.error(error));
        };
        getDesgination();
    }, [companyCode]);
    const getLogo = (code) => {
        switch (code) {
            case '10':
                return pitcLogo
            case '11':
                return LESCOLOGO
            case '12':
                return GEPCOLOGO
            case '13':
                return FESCOLOGO
            case '14':
                return IESCOLOGO
            case '15':
                return MEPCOLOGO
            case '26':
                return PESCOLOGO
            case '27':
                return HAZECOLOGO
            case '37':
                return HESCOLOGO
            case '38':
                return SEPCOLOGO
            case '48':
                return QESCOLOGO
            case '59':
                return TESCOLOGO
            default:
                return MEPCOLOGO
        }
    }
    const getCompanies = (code) => {
        switch (code) {
            case '10':
                return "Power Information Technology Company"
            case '11':
                return "Lahore Electric Supply Company"
            case '12':
                return "Gujranwala Electric Power Company"
            case '13':
                return "Faisalabad Electric Supply Company"
            case '14':
                return "Islamabad Electric Supply Company"
            case '15':
                return "Multan Electric Power Company"
            case '26':
                return "Peshawar Electric Supply Company"
            case '27':
                return "Hazara Electric Supply Company"
            case '38':
                return "Sukkur Electric Power Company"
            case '37':
                return "Hyderabad Electric Supply Company"
            case '48':
                return "Quetta Electric Supply Company"
            case '59':
                return "Tribal Electric Supply Company"

        }
    }
    const handleChangeDesgination = (e) => {
        console.log(e.target.value, 'e.target.value');
        const selectedId = e.target.value;

        setDesginationCodeToApi(selectedId);
        const selectedObj = desginationList.find(item => item.employeeDesignationId.toString() === selectedId);
    if (selectedObj) {
        setDesginationName(selectedObj.employeeDesignationName); // <-- store name only
    }
    };
    const DownloadPdf = async (print) => {
        return new Promise((resolve, reject) => {
            let offName = officeName;
            let dateToPrint = getCurrentDateFormatted(new Date);

            // Define header structure
            const headers = [
                [
                    {
                        content:
                            OffLevel === 2
                                ? "CIRCLE"
                                : OffLevel === 3
                                    ? "DIVISION"
                                    : OffLevel === 4
                                        ? "SUBDIVISION"
                                        : OffLevel === 5
                                            ? "SUBDIVISION"
                                            : ""
                    },
                    { content: 'CIR/DIV/SDIV Name', },
                    { content: 'LoggedIn', },
                    { content: 'NotLoggedIn', },
                    { content: 'Total', },
                ]
            ];


            // Define data rows based on your table
            const body = [];

            if (tableData && tableData.length > 0) {
                // Add table rows
                tableData.forEach((item) => {
                    body.push([
                        item.officeCode || "-",
                        item.officeName || 0,
                        item.totalLoggedIn || 0,
                        item.totalLoggedOut || 0,
                        item.total || 0,
                    ]);
                });

                // ✅ Calculate totals properly
                const totalLoggedIn = tableData.reduce((sum, row) => sum + (row.totalLoggedIn || 0), 0);
                const totalLoggedOut = tableData.reduce((sum, row) => sum + (row.totalLoggedOut || 0), 0);
                const total = tableData.reduce((sum, row) => sum + (row.total || 0), 0);

                body.push([
                    "Total",
                    "-",
                    formatWithCommas(totalLoggedIn),
                    formatWithCommas(totalLoggedOut),
                    formatWithCommas(total),
                ]);
            } else {
                // No Data Message
                body.push(["No Data Found", "-", "-"]);
            }

            // Initialize PDF and set basic layout
            const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const logoWidth = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 25 : 30;
            const logoHeight = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 20 : 10;
            pdf.addImage(getLogo(companyCode), 'PNG', 15, 5, logoWidth, logoHeight);

            const eOpsLogoWidth = 20;
            const eOpsLogoHeight = 8;
            const eOpsLogoXPosition = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 43 : 17;
            pdf.addImage(eOpsLogo, 'PNG', eOpsLogoXPosition, companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 12 : 17, eOpsLogoWidth, eOpsLogoHeight);


            pdf.setFontSize(10);
            pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
            pdf.text("Name: " + name, pageWidth - 65, 17);
            pdf.text("Designation: " + roleName, pageWidth - 65, 22);


            pdf.setFontSize(12);
            pdf.text(getCompanies(companyCode), pageWidth / 2, 12, { align: 'center' });
            pdf.text(`Eops Mobile App Usage Summary`, pageWidth / 2, 18, { align: 'center' });
            pdf.setFontSize(10);
            pdf.text(`Eops Mobile App Usage Summary of ${desginationName} for ${offName} of ${dateToPrint}`, pageWidth / 2, 25, { align: 'center' });

            // Generate table in PDF
            pdf.autoTable({
                startY: 28,
                head: headers,
                body: body,
                styles: {
                    cellPadding: 1,
                    fontSize: 8,
                    halign: 'left',
                    lineWidth: 0.25,
                    lineColor: 'white'
                },
                margin: { top: 2 },
                theme: 'striped',
                headStyles: { valign: 'middle' },
                bodyStyles: {
                    halign: 'left', // Default alignment for all columns
                },
                columnStyles: {
                    0: { halign: 'left' }, // Align the first column ("Region Name") to the left
                },
                didParseCell: (data) => {
                    // Check if it's the "final row for ParentNode Totals"
                    if (data.row.raw[0] === "Total") {
                        data.cell.styles.fontStyle = 'bold'; // Make the font bold
                    }
                },
            });
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                const pageNumberText = `Page ${i} of ${totalPages}`;
                pdf.setFontSize(10);
                pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
            }

            // Save or download the PDF
            if (print) {
                pdf.save(`${desginationName}- ${offName}-${dateToPrint}-Eops-Mobile-App-Usage-Summary.pdf`);
            } else {
                resolve(pdf);
            }
        });
    };
    const exportToExcel = () => {
        let offName = officeName;
        let dateToPrint = convertDate(new Date());
        const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: 'Sheet1' });
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout]), `${desginationName}-${offName}-${dateToPrint} - Eops-Mobile-App-Usage-Summary.xlsx`);
    };

    const printPDF = async () => {
        let pdf = await DownloadPdf(false);
        const pdfUrl = pdf.output('bloburl');

        // Create an iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.src = pdfUrl;
        document.body.appendChild(iframe);

        // Create a cancel button
        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel';
        cancelButton.style.position = 'fixed';
        cancelButton.style.top = '20px';
        cancelButton.style.right = '20px';
        cancelButton.style.padding = '10px 20px';
        cancelButton.style.backgroundColor = '#ff4d4d';
        cancelButton.style.color = 'white';
        cancelButton.style.border = 'none';
        cancelButton.style.borderRadius = '5px';
        cancelButton.style.cursor = 'pointer';
        document.body.appendChild(cancelButton);

        // Print the PDF when the iframe loads
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        };

        // Remove iframe and cancel button when cancel button is clicked
        cancelButton.addEventListener('click', () => {
            if (iframe.parentNode) {
                document.body.removeChild(iframe);
            }
            if (cancelButton.parentNode) {
                document.body.removeChild(cancelButton);
            }
        });
    };

    function formatDecimalPoints(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(value);
    }

    function convertToMillion(openingBalance) {
        return (((openingBalance) / Math.pow(10, 6))).toFixed(2);
    }
    function getCurrentDateFormatted(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const options = { month: 'short' };
        const month = date.toLocaleString('en-US', options);
        const year = String(date.getFullYear()).slice(-2);
        return `${day}-${month}-${year}`;
    }

  // Fetch subDivisions for code == 10
   useEffect(() => {
     if (code == 10 && selectedCompanyCode) {
       const fetchSubDivisions = async () => {
         setIsLoading(true);
         const myHeaders = new Headers();
         myHeaders.append('Authorization', token);
         const formdata = new FormData();
         formdata.append('companyCode', selectedCompanyCode);
         const requestOptions = {
           method: 'POST',
           headers: myHeaders,
           body: formdata,
           redirect: 'follow',
         };
         try {
           const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
           if (response.ok) {
             const result = await response.json();
             if (result.status === '200') {
               setSubDivisions(result.message);
               setApiData(result.message);
               // Populate circles
               const circles = result.message.reduce((acc, curr) => {
                 if (!acc.some(item => item.circleCode === curr.circleCode)) {
                   acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                 }
                 return acc;
               }, []);
               setFilteredCircles(circles);
             } else {
               console.error('Error fetching subDivisions:', result.message);
               setSubDivisions([]);
               setFilteredCircles([]);
             }
           } else {
             throw new Error(`Request failed with status ${response.status}`);
           }
         } catch (error) {
           console.error('Error fetching subDivisions:', error);
           setSubDivisions([]);
           setFilteredCircles([]);
         } finally {
           setIsLoading(false);
         }
       };
       fetchSubDivisions();
     } else if (code != 10) {
       // For code != 10, populate circles from localStorage subDivisions
       const circles = subDivisions.reduce((acc, curr) => {
         if (!acc.some(item => item.circleCode === curr.circleCode)) {
           acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
         }
         return acc;
       }, []);
       setFilteredCircles(circles);
     }
   }, [code, selectedCompanyCode, token, cfpBaseUrl]);
 
   const handleChangeCompany = async (e) => {
     const selectedCompany = e.target.value;
     setSelectedCompanyCode(selectedCompany);
     setOfficeCode(selectedCompany);
     setOfficeName(getCompanies(selectedCompany) || '');
 
     if (code == 10 && selectedCompany) {
       setIsLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompany);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             // Reset dropdowns
             setCircleCode('');
             setSelectedDivision('');
             setSelectedSubDivision('');
             setCircleName('');
             setFilteredDivisions([]);
             setFilteredSubDivisions([]);
 
             // Populate circles
             const circles = result.message.reduce((acc, curr) => {
               if (!acc.some(item => item.circleCode === curr.circleCode)) {
                 acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
               }
               return acc;
             }, []);
             setFilteredCircles(circles);
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
             setFilteredCircles([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
         setFilteredCircles([]);
       } finally {
         setIsLoading(false);
       }
     } else if (!selectedCompany) {
       // Reset when no company is selected
       setOfficeName('PITC');
       setCircleCode('');
       setSelectedDivision('');
       setSelectedSubDivision('');
       setCircleName('');
       setFilteredDivisions([]);
       setFilteredSubDivisions([]);
       setFilteredCircles([]);
       setSubDivisions([]);
       setApiData([]);
     }
   };
 
   const handleCircleChange = async (event) => {
     const selectedCircleCode = event.target.value ? parseInt(event.target.value) : '';
     if (code == 10 && selectedCircleCode && selectedCompanyCode) {
       setIsLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       formdata.append('circleCode', selectedCircleCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setCircleCode(selectedCircleCode);
             setOfficeCode(selectedCircleCode);
             const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
             const circleName = circle?.circleName || '';
             setOfficeName(circleName.concat(' Circle'));
             setCircleName(circleName);
             setSelectedDivision('');
             setSelectedSubDivision('');
             setFilteredSubDivisions([]);
 
             // Populate divisions
             const uniqueDivisions = result.message
               .filter(item => item.circleCode === selectedCircleCode)
               .reduce((acc, item) => {
                 if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                   acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                 }
                 return acc;
               }, []);
             setFilteredDivisions(uniqueDivisions);
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
             setFilteredDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
         setFilteredDivisions([]);
       } finally {
         setIsLoading(false);
       }
     } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
       // Handle "All Circle" selection for code == 10
       setIsLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setCircleCode('');
             setOfficeCode(selectedCompanyCode);
             setOfficeName(getCompanies(selectedCompanyCode));
             setCircleName('');
             setSelectedDivision('');
             setSelectedSubDivision('');
             setFilteredSubDivisions([]);
 
             // Populate divisions
             const uniqueDivisions = result.message.reduce((acc, item) => {
               if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                 acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
               }
               return acc;
             }, []);
             setFilteredDivisions(uniqueDivisions);
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
             setFilteredDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
         setFilteredDivisions([]);
       } finally {
         setIsLoading(false);
       }
     } else if (selectedCircleCode) {
       setCircleCode(selectedCircleCode);
       setOfficeCode(selectedCircleCode);
       const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
       const circleName = circle?.circleName || '';
       setOfficeName(circleName.concat(' Circle'));
       setCircleName(circleName);
       setSelectedDivision('');
       setSelectedSubDivision('');
       setFilteredSubDivisions([]);
       const uniqueDivisions = subDivisions
         .filter(item => item.circleCode === selectedCircleCode)
         .reduce((acc, item) => {
           if (!acc.some(division => division.divisionCode === item.divisionCode)) {
             acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
           }
           return acc;
         }, []);
       setFilteredDivisions(uniqueDivisions);
     } else {
       // Handle "All Circle" for code != 10
       setCircleCode('');
       setSelectedDivision('');
       setSelectedSubDivision('');
       setFilteredSubDivisions([]);
       if (roleTypeName == 'Technical') {
         if (offCode) {
           setOfficeCode(offCode == 10 ? 15 : offCode);
           let officeName = getName(offCode == 10 ? '15' : offCode.toString(), subDivisions);
           setOfficeName(officeName.concat(' Region'));
           setCircleName('');
           const circles = subDivisions.reduce((acc, curr) => {
             if (!acc.some(item => item.circleCode === curr.circleCode)) {
               acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
             }
             return acc;
           }, []);
           setFilteredCircles(circles);
           const uniqueDivisions = subDivisions.reduce((acc, item) => {
             if (!acc.some(division => division.divisionCode === item.divisionCode)) {
               acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
             }
             return acc;
           }, []);
           setFilteredDivisions(uniqueDivisions);
         }
       } else if (roleTypeName == 'Commercial') {
         if (cfcLevelId == 2) {
           if (offCode) {
             setOfficeCode(offCode.toString().slice(0, 2));
             let offName = cscID;
             setOfficeName(offName);
             setHierarchy(cfcLevelId);
             const uniqueDivisions = subDivisions.reduce((acc, item) => {
               if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                 acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
               }
               return acc;
             }, []);
             setFilteredDivisions(uniqueDivisions);
           }
         } else if (cfcLevelId == 3) {
           if (offCode) {
             setOfficeCode(offCode.toString().slice(0, 3));
             let offName = cscID;
             setOfficeName(offName);
             setHierarchy(cfcLevelId);
             const uniqueDivisions = subDivisions.reduce((acc, item) => {
               if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                 acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
               }
               return acc;
             }, []);
             setFilteredDivisions(uniqueDivisions);
           }
         }
       }
     }
   };
 
   const handleDivisionChange = async (e) => {
     const selectedDivisionCode = parseInt(e.target.value);
     if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
       setIsLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       formdata.append('divisionCode', selectedDivisionCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setSelectedDivision(selectedDivisionCode);
             setOfficeCode(selectedDivisionCode);
             const division = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode);
             const divisionName = division?.divisionName || '';
             setOfficeName(divisionName.concat(' Division'));
             setSelectedSubDivision('');
             const uniqueSubDivisions = result.message
               .filter(item => item.divisionCode == selectedDivisionCode)
               .reduce((acc, item) => {
                 if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                   acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                 }
                 return acc;
               }, []);
             setFilteredSubDivisions(uniqueSubDivisions);
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
             setFilteredSubDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
         setFilteredSubDivisions([]);
       } finally {
         setIsLoading(false);
       }
     } else if (selectedDivisionCode) {
       setSelectedDivision(selectedDivisionCode);
       setOfficeCode(selectedDivisionCode);
       const divisionName = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode)?.divisionName || '';
       setOfficeName(divisionName.concat(' Division'));
       setSelectedSubDivision('');
       const uniqueSubDivisions = subDivisions
         .filter(item => item.divisionCode == selectedDivisionCode)
         .reduce((acc, item) => {
           if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
             acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
           }
           return acc;
         }, []);
       setFilteredSubDivisions(uniqueSubDivisions);
     } else {
       setSelectedDivision('');
       setOfficeCode(circleCode ? circleCode : offCode);
       let officeName = getName(circleCode ? circleCode.toString() : offCode.toString(), subDivisions);
       setOfficeName(officeName.concat(' Circle'));
       setSelectedSubDivision('');
       setFilteredSubDivisions([]);
       const uniqueDivisions = subDivisions
         .filter(item => item.circleCode == (circleCode ? circleCode : offCode))
         .reduce((acc, item) => {
           if (!acc.some(division => division.divisionCode === item.divisionCode)) {
             acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
           }
           return acc;
         }, []);
       setFilteredDivisions(uniqueDivisions);
     }
   };
 
   const handleSubDivisionChange = async (e) => {
     const selectedSubDivisionCode = parseInt(e.target.value);
     if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
       setIsLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       formdata.append('subDivisionCode', selectedSubDivisionCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setSelectedSubDivision(selectedSubDivisionCode);
             setOfficeCode(selectedSubDivisionCode);
             const subDivision = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode);
             const subDivisionName = subDivision?.subDivisionName || '';
             setOfficeName(subDivisionName.concat(' Sub Division'));
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
       } finally {
         setIsLoading(false);
       }
     } else if (selectedSubDivisionCode) {
       setSelectedSubDivision(selectedSubDivisionCode);
       setOfficeCode(selectedSubDivisionCode);
       const subDivisionName = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode)?.subDivisionName || '';
       setOfficeName(subDivisionName.concat(' Sub Division'));
     } else {
       setSelectedSubDivision('');
       let officeName = getName(selectedDivision ? selectedDivision.toString() : offCode.toString(), subDivisions);
       setOfficeName(officeName.concat(' Division'));
       setOfficeCode(selectedDivision ? selectedDivision : offCode);
     }
   };
 
   useEffect(() => {
     if (roleTypeName == 'Technical') { 
       if (offCode) {
         setOfficeCode(offCode == 10 ? 15 : offCode);
         let offName = getName(offCode == 10 ? '15' : offCode.toString(), subDivisions);
         setOfficeName(offName); 
         setHierarchy(offCode.toString().length);
       }
     } else if (roleTypeName == 'Commercial') {
       if (cfcLevelId == 1) {
         if (offCode) {
                              if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
                          }
       } else if (cfcLevelId == 2) {
         if (offCode) {
           setOfficeCode(offCode.toString().slice(0, 2));
           let offName = cscID;
           setOfficeName(offName);
           setHierarchy(cfcLevelId);
         }
       } else if (cfcLevelId == 3) {
         if (offCode) {
           setOfficeCode(offCode.toString().slice(0, 3));
           let offName = cscID;
           setOfficeName(offName);
           setHierarchy(cfcLevelId);
         }
       } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
     }
   }, [offCode, cfcLevelId, roleTypeName, cscID]);
 
   useEffect(() => {
     if (hierarchy) {
       if (hierarchy == 1 || cfcLevelId === 1) {
         console.log('1 wala if');
         let circles = subDivisions.reduce((acc, curr) => {
           if (!acc.some(item => item.circleCode === curr.circleCode)) {
             acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
           }
           return acc;
         }, []);
         setFilteredCircles(circles);
       } else if (hierarchy == 2 || cfcLevelId == 2) {
         console.log('2 wala if');
         let circles = subDivisions.reduce((acc, curr) => {
           if (!acc.some(item => item.circleCode === curr.circleCode)) {
             acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
           }
           return acc;
         }, []);
         setFilteredCircles(circles);
       } else if (hierarchy == 3 || cfcLevelId == 3) {
         console.log('3 wala if');
         setCircleCode(offCode.slice(0, 3));
         console.log(offCode.slice(0, 3), 'djlsahjdhalhdalhlkd');
         const uniqueDivisions = subDivisions
           .filter(item => item.circleCode == offCode.slice(0, 3))
           .reduce((acc, item) => {
             if (!acc.some(division => division.divisionCode === item.divisionCode)) {
               acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
             }
             return acc;
           }, []);
         setFilteredDivisions(uniqueDivisions);
       } else if ((hierarchy == 4 || cfcLevelId == 4) || (hierarchy == 5 || cfcLevelId == 5)) {
         console.log('4 wala if');
         setSelectedDivision(offCode.slice(0, 4));
         const uniqueSubDivisions = subDivisions
           .filter(item => item.divisionCode == offCode.slice(0, 4))
           .reduce((acc, item) => {
             if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
               acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
             }
             return acc;
           }, []);
         setFilteredSubDivisions(uniqueSubDivisions);
       }
     }
   }, [hierarchy, cfcLevelId, subDivisions]);
    const connectionTypes = [
        OffLevel === 2
            ? "CIRCLE"
            : OffLevel === 3
                ? "DIVISION"
                : OffLevel === 4
                    ? "SUBDIVISION"
                    : OffLevel === 5
                        ? "SUBDIVISION"
                        : "",
        'CIR/DIV/SDIV Name',
        'LoggedIn',
        'NotLoggedIn',
        'Total',
    ];

    const fetchData = async (officeCode, roleId) => {
        setIsLoading(true); // Start loader
        if (officeCode) {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", token);

            const raw = JSON.stringify({
                "officecode": officeCode,
                "roleId": roleId
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            try {
                const response = await fetch(
                    cfpBaseUrl + "/reports/geteOpsMobileAppUsageSummary",
                    requestOptions
                );
                const result = await response.json();
                if (result.status === '200') {
                    const data = result.data
                    console.log("Data fetched successfully:", data);
                    if (data) {
                        setTableData(data);
                        setIsLoading(false);
                    } else {
                        setTableData('')
                        setIsLoading(false);
                    }
                } else {
                    console.error("Error: ", result.message);
                    setTableData('')
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Fetch Error: ", error);
            } finally {
                setIsLoading(false); // Stop loader
            }
        }

    };

 

    function formatWithCommas(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const currentFilters = {
   officeCode, desginationCodeToApi
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged = JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
  officeCode, desginationCodeToApi
  ]);

  const handleGoClick = () => {
    fetchData(officeCode, desginationCodeToApi)

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

    return (
        <>
            <Box className='form-box'>
                <div style={{ display: 'flex', flexDirection: "row" }}>
                    <Box className='application-table' style={{ marginRight: '10px', height: '100%' }}>
                        <h3 style={{ color: '#006ad1', marginBottom: '10px' }}> e-Ops Mobile App Usage Summary Report</h3>
                        <div className='div-datagrid' style={{ height: '100%' }}>
                            <div className='reports-container' >
                                <div className='filter-fields' style={{ width: '75%', justifyContent: 'flex-start', gap: '15px' }}>
                                    <div className='field-container'>
                                        <Typography className='field-label'>Desgination</Typography>
                                        <select
                                            className='dropdown-field'
                                            style={{ backgroundColor: 'white' }}
                                            value={desginationCodeToApi}
                                            onChange={handleChangeDesgination}>
                                            {desginationList.map((item, index) => (
                                                <option key={index} value={item.employeeDesignationId}>{item.employeeDesignationName}</option>
                                            ))}
                                        </select>
                                    </div>
                                   {code == 10 && (
                                                        <div className="field-container">
                                                          <Typography className="field-label">Company</Typography>
                                                          <select
                                                            className="dropdown-field"
                                                            style={{ backgroundColor: 'white' }}
                                                            value={selectedCompanyCode}
                                                            onChange={handleChangeCompany}
                                                          >
                                                            <option value="10">Select Company</option>
                                                            <option value="11">LESCO</option>
                                                            <option value="12">GEPCO</option>
                                                            <option value="13">FESCO</option>
                                                            <option value="14">IESCO</option>
                                                            <option value="15">MEPCO</option>
                                                            <option value="26">PESCO</option>
                                                            <option value="27">HAZECO</option>
                                                            <option value="37">HESCO</option>
                                                            <option value="38">SEPCO</option>
                                                            <option value="48">QESCO</option>
                                                            <option value="59">TESCO</option>
                                                          </select>
                                                        </div>
                                                      )}
                                    
                                                      {hierarchy <= 2 && (
                                                        <div className="field-container">
                                                          <Typography className="field-label">Circle</Typography>
                                                          <select
                                                            className="dropdown-field"
                                                            style={{ backgroundColor: 'white' }}
                                                            value={circleCode || ''}
                                                            onChange={handleCircleChange}
                                                          >
                                                            <option value="">All Circle</option>
                                                            {filteredCircles.map((circle) => (
                                                              <option key={circle.circleCode} value={circle.circleCode}>
                                                                {circle.circleName}
                                                              </option>
                                                            ))}
                                                          </select>
                                                        </div>
                                                      )}
                                    
                                                      {hierarchy <= 3 && (
                                                        <div className="field-container">
                                                          <Typography className="field-label">Division</Typography>
                                                          <select
                                                            className="dropdown-field"
                                                            style={{ backgroundColor: 'white' }}
                                                            value={selectedDivision || ''}
                                                            onChange={handleDivisionChange}
                                                            disabled={!circleCode}
                                                          >
                                                            <option value="">All Division</option>
                                                            {filteredDivisions.map((division) => (
                                                              <option key={division.divisionCode} value={division.divisionCode}>
                                                                {division.divisionName}
                                                              </option>
                                                            ))}
                                                          </select>
                                                        </div>
                                                      )}
                                    
                                                      {hierarchy <= 4 && (
                                                        <div className="field-container">
                                                          <Typography className="field-label">Sub-Division</Typography>
                                                          <select
                                                            className="dropdown-field"
                                                            style={{ backgroundColor: 'white' }}
                                                            value={selectedSubDivision || ''}
                                                            onChange={handleSubDivisionChange}
                                                            disabled={!selectedDivision}
                                                          >
                                                            <option value="">All Sub-Division</option>
                                                            {filteredSubDivisions.map((subDivision) => (
                                                              <option key={subDivision.subDivisionCode} value={subDivision.subDivisionCode}>
                                                                {subDivision.subDivisionName}
                                                              </option>
                                                            ))}
                                                          </select>
                                                        </div>
                                                      )}
                                  
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                style={{ marginTop: '10px' }}
                                                onClick={handleGoClick}
        disabled={isGoDisabled || isLoading}
                                            >
                                                Go
                                            </Button>
                                    <div className='field-container'>
                                        <Typography className='field-label'></Typography>
                                        <input style={{ display: 'none' }}></input>
                                    </div>
                                    <div className='field-container'>
                                        <Typography className='field-label'> </Typography>
                                        <input style={{ display: 'none' }} type='date' className='date-field' />
                                    </div>

                                    {/* <div className='field-container'>
                                        <button onClick={handleClick} className='primary-button'>
                                            <SearchIcon id="searchBtn" sx={{ color: 'white' }} />
                                        </button>
                                    </div> */}
                                </div>
                                <div className="export-button-container">

                                     <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                                </div>
                            </div>
                            <div style={{ marginLeft: '4px', display: 'flex', justifyContent: 'center', backgroundColor: 'rgb(213, 229, 255)', color: 'black' }}>
                                <Typography variant="h6" style={{ color: 'black' }}>
                                    e-Ops Mobile App Usage Summary Report of {desginationName} for {officeName} As Of ({getCurrentDateFormatted(new Date)})
                                </Typography>
                            </div>


                            <table
                                ref={tableRef}
                                style={{ borderCollapse: "collapse", width: '100%', backgroundColor: "white" }}
                            >
                                <thead>
                                    <tr style={{ position: 'sticky', top: '0', backgroundColor: 'white', zIndex: 1 }}>
                                        {connectionTypes.map((type, index) => (
                                            <th
                                                key={index}
                                                style={{
                                                    width: `${100 / connectionTypes.length}%`,
                                                    textAlign: 'left',
                                                    border: '5px solid white',
                                                    backgroundColor: '#eeeff0',
                                                    color: 'black',
                                                    fontSize: '15px',
                                                    fontFamily: 'Roboto-Medium',
                                                    padding: '5px'
                                                }}
                                            >
                                                {type}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td
                                                colSpan={connectionTypes.length}
                                                style={{ textAlign: "center", padding: "20px" }}
                                            >
                                                <Box display="flex" justifyContent="center" alignItems="center">
                                                    <CircularProgress />
                                                </Box>
                                            </td>
                                        </tr>
                                    ) : tableData && tableData.length > 0 ? (
                                        <>
                                            {tableData.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{ backgroundColor: "white", borderBottom: "1px solid #ccc" }}
                                                >
                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                        {item.officeCode}
                                                    </td>
                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                        {item.officeName}
                                                    </td>
                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                        {item.totalLoggedIn}
                                                    </td>
                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                        {item.totalLoggedOut}
                                                    </td>
                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                        {item.total}
                                                    </td>
                                                </tr>
                                            ))}

                                            {/* ✅ Total Row */}
                                            <tr style={{ backgroundColor: "#fef5c0", fontWeight: "bold" }}>
                                                <td

                                                    style={{ padding: "5px", textAlign: "left", fontSize: "14px", fontWeight: 'bolder' }}
                                                >
                                                    Total
                                                </td>
                                                <td style={{ padding: "5px", textAlign: "left", fontSize: "14px", fontWeight: 'bolder' }}>
                                                    -
                                                </td>
                                                <td style={{ padding: "5px", textAlign: "left", fontSize: "14px", fontWeight: 'bolder' }}>
                                                    {formatWithCommas(tableData.reduce((sum, row) => sum + row.totalLoggedIn, 0))}
                                                </td>
                                                <td style={{ padding: "5px", textAlign: "left", fontSize: "14px", fontWeight: 'bolder' }}>
                                                    {formatWithCommas(tableData.reduce((sum, row) => sum + row.totalLoggedOut, 0))}
                                                </td>
                                                <td style={{ padding: "5px", textAlign: "left", fontSize: "14px", fontWeight: 'bolder' }}>
                                                    {formatWithCommas(tableData.reduce((sum, row) => sum + row.total, 0))}
                                                </td>
                                            </tr>
                                        </>
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={connectionTypes.length}
                                                style={{
                                                    textAlign: "center",
                                                    padding: "10px",
                                                    fontWeight: "bold",
                                                    color: "red",
                                                }}
                                            >
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>



                            </table>


                        </div>
                    </Box>
                </div>
            </Box>

        </>
    )
}

export default EopsMobileAppUsageSummary